import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import HomeV2 from "@/pages/HomeV2";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="grain min-h-screen bg-ink font-sans text-white antialiased">
        <Toaster
          theme="dark"
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#0A0B0E",
              border: "1px solid rgba(0,255,102,0.35)",
              color: "#FFFFFF",
              fontFamily: '"JetBrains Mono", monospace',
            },
          }}
        />
        <Routes>
          <Route path="/" element={<HomeV2 />} />
          <Route path="/home-v2" element={<HomeV2 />} />
          <Route path="/home-v1" element={<Home />} />
          <Route path="*" element={<HomeV2 />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
